import { Link } from "react-router-dom";
const COPY = {
  privacy: {
    title: "Privacy Policy",
    intro:
      "How DIR Nation handles account, community and engagement information.",
    sections: [
      [
        "Information we collect",
        "We collect information you provide when you create an account, update your profile, subscribe, contact us or interact with published content.",
      ],
      [
        "How information is used",
        "Information supports account access, member features, moderation, platform security, service improvement and communications you choose to receive.",
      ],
      [
        "Visibility and choices",
        "Profile and heritage visibility controls determine what other members can see. You may update these choices from your member dashboard.",
      ],
      [
        "Contact",
        "For privacy questions or account requests, contact the DIR Nation team through the Contact page.",
      ],
    ],
  },
  terms: {
    title: "Terms of Use",
    intro:
      "The standards that support a useful and respectful DIR Nation community.",
    sections: [
      [
        "Using the platform",
        "Use DIR Nation lawfully, provide accurate account information and protect your login credentials.",
      ],
      [
        "Community participation",
        "Do not publish abusive, deceptive, unlawful or rights-infringing material. Moderators may review or remove content that violates these standards.",
      ],
      [
        "Published information",
        "Heritage and editorial material may evolve as research is reviewed. External classification notes are presented with appropriate context.",
      ],
      [
        "Contact",
        "Questions about these terms can be sent through the Contact page.",
      ],
    ],
  },
  cookies: {
    title: "Cookie Policy",
    intro:
      "How essential storage and privacy-conscious analytics support the website.",
    sections: [
      [
        "Essential storage",
        "Authentication and preference storage keep sessions secure and remember choices needed for the platform to function.",
      ],
      [
        "Analytics",
        "Public-route analytics help DIR Nation understand aggregate website use. Private member and Admin Studio routes are excluded from page-view tracking.",
      ],
      [
        "Your choices",
        "Browser settings can restrict non-essential storage, though blocking essential storage may prevent account features from working.",
      ],
    ],
  },
};
export function LegalPage({ type }) {
  const page = COPY[type];
  return (
    <main className="min-h-screen bg-dir-bg px-4 pb-20 pt-32 text-dir-text sm:px-6">
      <article className="mx-auto max-w-3xl rounded-3xl border border-dir-gold/15 bg-dir-card p-6 shadow-2xl sm:p-10">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-dir-gold">
          DIR Nation
        </p>
        <h1 className="mt-3 font-display text-4xl font-bold sm:text-5xl">
          {page.title}
        </h1>
        <p className="mt-4 text-lg leading-8 text-dir-muted">{page.intro}</p>
        <div className="mt-10 space-y-8">
          {page.sections.map(([heading, body]) => (
            <section key={heading}>
              <h2 className="font-display text-xl font-semibold">{heading}</h2>
              <p className="mt-2 leading-7 text-dir-muted">{body}</p>
            </section>
          ))}
        </div>
        <p className="mt-10 border-t border-dir-gold/10 pt-6 text-sm text-dir-faint">
          Last updated August 2026.{" "}
          <Link to="/contact" className="text-dir-gold hover:underline">
            Contact DIR Nation
          </Link>
        </p>
      </article>
    </main>
  );
}
export function NotFound() {
  return (
    <main className="flex min-h-[80vh] items-center justify-center bg-dir-bg px-4 pt-24 text-center">
      <div>
        <p className="text-sm font-bold uppercase tracking-[0.25em] text-dir-gold">
          404
        </p>
        <h1 className="mt-4 font-display text-4xl font-bold text-dir-text sm:text-6xl">
          This page could not be found
        </h1>
        <p className="mx-auto mt-4 max-w-xl text-dir-muted">
          The link may have changed, or the page is no longer available.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex min-h-11 items-center rounded-full bg-dir-gold px-6 font-bold text-dir-deep hover:brightness-110"
        >
          Return home
        </Link>
      </div>
    </main>
  );
}
